import { apiClient, TruckbookApiResponse } from '../axiosClient'
import { Booking } from './checkBookingExistence'

type WorkRecordResponse = TruckbookApiResponse<{
  booking: Booking
}>

export const patchBookingWorkRecord = async (
  bookingId: string
): Promise<WorkRecordResponse> => {
  const { data } = await apiClient.patch<WorkRecordResponse>(
    `/berths/booking/${bookingId}/record-work-log`
  )
  return data
}
